(function () {
  class LoanRestructure extends Common {
    constructor() {
      super()
    };

    configure() {
      // BY ID
      this.ui.dni = "#dni";
      this.ui.fullname = "#fullname";
      this.ui.cellphone = "#loan_restructure_cellphone_number";

      // BY CLASS
      this.ui.jsSimulateBtn = '.js-simulate';
      this.ui.jsCreateLoanRestructuresBtn = ".js-create-loan-restructure-btn"
      this.ui.jsCreateLoanRestructures = "form.js-create-loan-restructures";
      this.ui.jsSignContract = ".js-sign-contract";
    };

    loadComponents() {
      this.configure();
      this.needFormValidation();
    };

    sendSimulateForm(url) {
      const operation = this;

      $(operation.ui.jsSimulateBtn).on('click', function (evt) {
        var form = $(operation.ui.jsFormValidation);

        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();

        form.valid();

        if (!form.valid()) {
          return false;
        };

        var showUntil = moment().add(1, 'seconds');
        var dialog = bootbox.dialog({
          centerVertical: true,
          closeButton: false,
          message: '<p class="text-center"><i class="fas fa-sync fa-spin fa-4x"></i></p>' +
            '<h5 class="text-center">Procesando...</h5>'
        });

        $.ajax({
          method: "POST",
          url: url,
          data: form.serialize()
        }).done(function () {
          console.log("Done!");
        }).fail(function () {
          console.log("error");
        });

        var show = showUntil - moment()

        if (show < 0) {
          dialog.modal('hide');
        } else {
          setTimeout(function () { dialog.modal('hide'); }, show);
        };
      });
    };

    sendCreateLoanRestructure() {
      const operation = this;

      $(operation.ui.jsCreateLoanRestructuresBtn).on('click', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();

        Swal.fire({
          title: i18n.t('messages.loan_restructure.modal_title'),
          html: i18n.t('messages.loan_restructure.modal_message_html'),
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#69BE5A',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            $(operation.ui.jsCreateLoanRestructures).submit();

            bootbox.dialog({
              centerVertical: true,
              closeButton: false,
              message: '<p class="text-center"><i class="fas fa-sync fa-spin fa-4x"></i></p>' +
                '<h5 class="text-center">Procesando...</h5>'
            });
          }
        });

        return false;
      });
    };

    loadSignContract() {
      const operation = this;

      $(operation.ui.jsSignContract).on('click', function (evt) {
        var form = $(operation.ui.jsFormValidation);

        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();

        form.valid();

        if (!form.valid()) {
          return false;
        };

        $.ajax({
          method: "POST",
          url: Routes.loan_messages_path(),
          dataType: 'script',
          data: {
            loan_message: {
              msg_type: 'restructure',
              dni: $(operation.ui.dni).val(),
              cellphone: $(operation.ui.cellphone).val(),
              fullname: $(operation.ui.fullname).val(),
              loan_type: 'cellular'
            }
          }
        }).done(function () {
          console.log("Done!");
        }).fail(function () {
          console.log("Error");
        });

        return false;
      });
    };

    changeBtnForm(value) {
      const operation = this;

      if (value === 'true') {
        $(operation.ui.jsCreateLoanRestructuresBtn).removeClass('d-none');
        $(operation.ui.jsCreateLoanRestructuresBtn).removeAttr('disabled');
        $('.js-sign-contract').remove();
      } else {
        $(operation.ui.jsCreateLoanRestructuresBtn).addClass('d-none');
      }
    };
  };

  window.LoanRestructure = LoanRestructure;
})();
